export default __webpack_public_path__ + "static/caseStudiesHero-10cecd64525af9fc28a62c659975f9ff.png";